<div class="page-container">
  @if (pageLoading) {
  <app-loading-modal [content]="'loading box details'"></app-loading-modal>
  } @if (cartLoading) {
  <app-loading-modal [content]="'loading cart'"> </app-loading-modal>
  }
  <app-page-content-wrapper [goBack]="goBack.bind(this)">
    <div class="page-title">
      <h1>Review & Add to Cart</h1>
    </div>
    <div class="page-content">
      <div class="row">
        <div class="col-1 left-column">
          <div *ngIf="showOutsideButton">
            <button
              (click)="setActiveButton('outsideArt')"
              aria-label="View Outside Art"
              [ngClass]="{
                active: activeButton === 'outsideArt',
                inactive: activeButton !== 'outsideArt'
              }"
            >
              <img src="assets/cb/images/upload_art_white.svg" alt="" />
            </button>
            <div class="btn-label">Outside Art</div>
          </div>
          <div *ngIf="showInsideButton">
            <button
              (click)="setActiveButton('insideArt')"
              aria-label="View Inside Art"
              [ngClass]="{
                active: activeButton === 'insideArt',
                inactive: activeButton !== 'insideArt'
              }"
            >
              <img src="assets/cb/images/upload_art_white.svg" alt="" />
            </button>
            <div class="btn-label">Inside Art</div>
          </div>
        </div>
        <div class="col-8 center-column">
          @if (activeButton === 'insideArt') {
          <img [src]="insideImage" class="w-100" alt="Preview of the inside artwork on your box" />
          } @if (activeButton === 'outsideArt') {
          <img [src]="outsideImage" class="w-100" alt="Preview of the outside artwork on your box" />
          }
        </div>
        <div class="col-3 right-column" style="background-color: white">
          <div class="box-details-container pt-2">
            @if (!isPaddedMailer && !isTissue) {
            <h2 class="column-button">My Box Details</h2>
            } @if (isPaddedMailer) {
            <h2 class="column-button">My Mailer Details</h2>
            }  @if (isTissue) {
            <h2 class="column-button">My Tissue Details</h2>
            }
            <div class="column-header" [innerHTML]="state().productDetails.categoryName?.toUpperCase()"></div>
            <div class="details-content">
              <div>
                {{ getWholeNumber(length) }}@if (convertDecimalToFraction(length)[0] !== '0') {
                <span
                  ><sup>{{ convertDecimalToFraction(length)[0] }}</sup
                  >&frasl;<sub>{{ convertDecimalToFraction(length)[1] }}</sub></span
                >
                } x
                {{ getWholeNumber(width) }}@if (convertDecimalToFraction(width)[0] !== '0') {
                <span
                  ><sup>{{ convertDecimalToFraction(width)[0] }}</sup
                  >&frasl;<sub>{{ convertDecimalToFraction(width)[1] }}</sub></span
                >
                } @if (getWholeNumber(depth) === 0) {
                <span> (in)</span>
                }
                <!-- Don't display the depth if it is equal to 0 -->
                @if (getWholeNumber(depth) !== 0) {
                <span>
                  x {{ getWholeNumber(depth) }}@if (convertDecimalToFraction(depth)[0] !== '0') {
                  <span
                    ><sup>{{ convertDecimalToFraction(depth)[0] }}</sup
                    >&frasl;<sub>{{ convertDecimalToFraction(depth)[1] }}</sub></span
                  >
                  } (in)</span
                >
                }
              </div>
              @if (!isTissue) {
                <div>{{ getPrintingSide() }} Printing</div>
                <div>
                  {{ state().productDetails.BoardStrength }} ECT {{ boxData?.boardType?.name }} {{ state().productDetails.outerMaterial }} /
                  {{ state().productDetails.innerMaterial }}
                </div>
              }
            </div>

            <mat-label for="quantity"><span class="qty-label">Quantity</span> </mat-label>
            @if (!customQuantityEntered) { @if (!isPizza && !isTissue && !isPaddedMailer) {
            <mat-select
              id="quantity"
              name="quantity"
              aria-label="Quantity"
              [(ngModel)]="selectedPrice"
              (ngModelChange)="stateSvc.updateState({ quantity: $event.quantity })"
              placeholder="{{ selectedPrice.quantity | number }} ({{ selectedPrice.pricePerUnit | currency }}) each"
            >
              @for (price of prices; track trackByFn($index, price)) {
              <mat-option [value]="price">
                {{ price.quantity | number }} ({{ price.pricePerUnit | currency }}
                each)
              </mat-option>
              }
            </mat-select>
            } @if (isTissue) {
              <mat-select
                id="quantity"
                name="quantity"
                aria-label="Quantity"
                [(ngModel)]="selectedPrice"
                (ngModelChange)="stateSvc.updateState({ quantity: $event.quantity })"
                placeholder="{{ selectedPrice?.quantity | number }} sheets ({{ (selectedPrice?.pricePerUnit ?? 0).toFixed(2) | currency }} / sheet)"
              >
                @for (price of prices; track $index) {
                  <mat-option [value]="price">
                    {{ price.quantity | number }} sheets ({{ (price.pricePerUnit ?? 0).toFixed(2) | currency }} per sheet)
                  </mat-option>
                }
              </mat-select>
            } @if (isPizza) {
            <mat-select
              id="quantity"
              name="quantity"
              aria-label="Quantity"
              [(ngModel)]="selectedPrice"
              (ngModelChange)="stateSvc.updateState({ quantity: $event.quantity })"
              placeholder="{{ selectedPrice.quantity | number }} ({{ selectedPrice.pricePerUnit | currency }}) each"
            >
              @for (price of prices; track trackByFn($index, price)) {
              <mat-option [value]="price">
                {{ price.quantity | number }} ({{ price.pricePerUnit | currency }}
                each)
              </mat-option>
              }
            </mat-select>
            } @if (isPaddedMailer) {
            <mat-select
              id="quantity"
              name="quantity"
              aria-label="Quantity"
              [(ngModel)]="selectedPrice"
              (ngModelChange)="stateSvc.updateState({ quantity: $event.quantity })"
              [disabled]="!prices"
              [placeholder]="selectedPrice.label"
            >
              @for (price of prices|slice:0:standardQuantities.length; track trackByFn(i, price); let i = $index) {
              <mat-option (click)="quantityArrayIndex = i" [value]="price">
                {{ price.label }}
              </mat-option>
              }
            </mat-select>
            } }

            <div *ngIf="customQuantityEntered">
              <input id="quantity"
                matInput
                aria-label="Custom quantity, click to change"
                (click)="showModal(customQuantity)"
                [ngModel]="enteredCustomPrice"
              />
            </div>
            @if (!customQuantityEntered && !isPizza && !isTissue && !isPaddedMailer) {
            <button type="button" class="quantity-link" (click)="showModal(customQuantity)">Enter a Custom Quantity</button>
            } @if (customQuantityEntered) {
            <button
              type="button"
              class="quantity-link"
              (click)="
                customQuantityEntered = !customQuantityEntered;
                customQuantityViolation = false;
                selectedPrice = prices[0];
                stateSvc.updateState({ quantity: selectedPrice.quantity })
              "
              >Select a Preset Quantity</button
            >
            } @if (customQuantityViolation) {
            <div class="custom-quantity-disclaimer" role="alert">
              This item has a minimum quantity of @if (state().productDetails.luxe) {
              <span>{{ prices[0].luxeMinimumOrder }}</span>
              }@if (!state().productDetails.luxe) {
              <span>{{ prices[0].minimumOrder }}</span>
              } and a maximum quantity of
              {{ prices[0].maxQuantity }}. Please adjust your quantity to meet these requirements.
            </div>
            }
            <div class="sample-offer">
              Note: to receive a sample of your completed box, select a quantity of 1. No digital proof will be emailed
              for orders with a quantity of 1.
            </div>
            <hr />
            <div class="subtotal-container">
              <div class="column-header" style="font-size: 18px">
                SUBTOTAL: {{ selectedPrice.totalPrice | currency }}
              </div>
            </div>
            <div class="approval-container">
              <div style="font-weight: bold">Approval</div>
              <div>
                A <span style="font-weight: bold">digital proof</span> of your custom box will be emailed within 24
                hours after order submission. You must
                <span style="font-weight: bold">approve the digital proof</span>
                before your box goes into production. If you don't receive your proof email, please check your spam or
                junk folder.
              </div>
              <div>I have verified the preview to be correct and will confirm approval upon receipt of the proof.</div>
              <div>
                I understand that once the checkout process is completed,
                <span style="font-weight: bold">no changes or cancellations can be made</span>.
              </div>
              <div>
                <mat-checkbox
                  (click)="disableBtn.set(!disableBtn())"
                  [checked]="disableBtn()"
                  [disabled]="customQuantityViolation"
                >
                  I accept and approve my artwork.</mat-checkbox
                >
              </div>
            </div>
            <div class="button-container text-center">
              <button
                type="button"
                [disabled]="customQuantityViolation || !disableBtn()"
                (click)="addToCart()"
                class="red-submit w-100"
              >
                ADD TO CART
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-page-content-wrapper>
  <form name="addToCart" #addToCartForm ngNoForm [action]="cartUrl()" method="post">
    <input name="action" type="hidden" value="add" />
    <input name="cxml-urlencoded" type="hidden" [value]="cxmlurlencoded()" />
  </form>
    <form name="back" #back ngNoForm [action]="state().referer" method="post">
    <input name="action" type="hidden" value="cancel" />
  </form>
</div>

<ng-template #customQuantity>
  <div class="modal-content custom-quantity">
    <div class="modal-body">
      <div class="container-fluid">
        <mat-label for="customQuantity">Enter Custom Quantity</mat-label><br />
        <input
          matInput
          aria-label="Enter custom quantity"
          (keyup.enter)="getPrice(); hide()"
          (keypress)="numberOnly($event)"
          [ngModel]="state().quantity"
          (ngModelChange)="stateSvc.updateState({ quantity: $event })"
          name="customQuantity"
          autocomplete="off"
        />
      </div>
      <div class="button-container">
        <button type="button" class="white-submit" (click)="getPrice(); hide()">OK</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #notFoundModal>
  <app-not-found-modal></app-not-found-modal>
</ng-template>
